export default __webpack_public_path__ + "static/media/SelfServeBrandOnboardingPlaybook.acbade19.pdf";